import { Slide, Fade } from 'react-awesome-reveal';

interface SideAreaTitleProps {
  title: string;
  subtitle?: string;
  colorClass?: string;
  TitleTag?: any;
  id?: string;
  isCentered?:boolean;
}

const SideAreaTitle = ({
  title,
  subtitle,
  colorClass,
  isCentered=false,
  TitleTag="h1",
  id,
}: SideAreaTitleProps) => {

  return <div className="pb-md-5 pb-4 ">
    <Slide delay={100} > 
      <TitleTag id={id} className={`fw-900 ${isCentered ? ' text-center' :''}`}>
        <span className={`${colorClass ? `border-bottom  ${colorClass}` : ''} ${isCentered ? ' text-center' :''}`}>{title}</span>
      </TitleTag>
     

    </Slide>

     {subtitle && <Fade delay={1000}><p className={` ${isCentered ? ' text-center' :''} mt-3`}>{subtitle}</p></Fade>}
  </div>

};

export default SideAreaTitle;
